<template>
  <div class="host-component">
    <h1 v-if="authed == false">Host – listening for iframe messages</h1>
    <div
      style="widows: 100%"
      class="d-flex flex-row justify-center"
      v-if="authed == false"
    >
      <!-- <iframe
        referrerpolicy="unsafe-url"
        ref="remote"
        :src="remoteUrl + '?host=devtrafficstats.renopd.com'"
        width="768"
        height="600"
        style="border: 1px solid #ccc"
      ></iframe> -->
      <iframe
        referrerpolicy="unsafe-url"
        ref="remote"
        :src="remoteUrl"
        width="768"
        height="600"
        style="border: 1px solid #ccc"
      ></iframe>
    </div>
    <div v-if="authed == true">
      <h1>The rest of the hosting app is here</h1>
    </div>
  </div>
</template>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "HostComponent",
  mixins: [bus_common],
  data() {
    return {
      authed: false,
      // URL of the Vue app that lives on Domain B
      remoteUrl: "https://citizen.rpdportal.org/",
      selfURL: "devtrafficstats.renopd.com",
    };
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
    overlay_prn: function () {
      return this.$store.state.overlay_prn_show;
    },
  },
  methods: {
    onMessage(event) {
      // // Accept messages only from Domain B
      // if (event.origin !== "https://citizen.rpdportal.org/") {
      //   return;
      // }
      console.log("event", event.data);
      let self = this;
      if (event.data.type == "Hello") {
        console.log("Message from B:", event.data.type, event.data.payload); // { type: 'Hello', payload: 'Ping' }
      }

      if (event.data.type == "Login" && self.emailIsValid(event.data.payload)) {
        console.log("Email :", event.data.payload);
        //console.log("Email valid:", self.emailIsValid(event.data.payload)); // { type: 'Hello', payload: 'Ping' }
        // if (self.emailIsValid(event.payload)) {
        console.log("authed");
        this.authed = true;
        self.authed = true;
        let user = {
          email: "",
          roles: "",
          token: "",
          rpduserId: 0,
          auth: false,
        };
        user.email = event.data.payload;
        user.auth = true;
        self.$store.commit("setUser", user);
        // }
      }
    },
  },
  mounted() {
    const frame = this.$refs.remote; // <iframe ref="theFrame" …>
    frame.addEventListener("load", () => {
      console.log("ears on");
      window.addEventListener("message", this.onMessage);
    });
  },
  beforeDestroy() {
    //  window.removeEventListener("message", this.onMessage);
  },
};
</script>
